import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Icon_YouTube",
  "use": "Icon_YouTube-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" id=\"Icon_YouTube\">\n<path fill=\"#fff\" d=\"M34.841,14.436c-0.326-1.219-1.286-2.179-2.507-2.505c-2.21-0.593-11.075-0.593-11.075-0.593\n\ts-8.863,0-11.074,0.593c-1.22,0.326-2.181,1.286-2.507,2.505c-0.592,2.212-0.592,6.824-0.592,6.824s0,4.613,0.592,6.823\n\tc0.326,1.22,1.287,2.181,2.507,2.506c2.211,0.593,11.074,0.593,11.074,0.593s8.865,0,11.075-0.593\n\tc1.221-0.325,2.181-1.286,2.507-2.506c0.593-2.21,0.593-6.823,0.593-6.823S35.434,16.648,34.841,14.436\" />\n<polygon fill=\"#000\" opacity=\"0.1\" points=\"18.425,25.513 25.789,21.26 18.425,17.007 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Icon_YouTube.svg
// module id = 590
// module chunks = 0